import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';

import { getProductList } from '../../../services/parametersService';

type ProductInputProps = SelectProps<any> & {
  onSelected?: (value: any, option: any) => void;
  allowclear?: boolean;
};

const ProductInput = ({
  onChange = noop,
  onSelected = noop,
  allowclear,
  ...otherProps
}: ProductInputProps) => {
  const { data: products, isFetching } = useGetProductList();

  const options: SelectProps<any>['options'] = useMemo(() => {
    return products?.map((product) => ({
      ...product,
      label: product.prlabel,
      value: product.prcode,
    }));
  }, [products]);

  const handleChange = (value: string, option: any) => {
    onChange(value, option);
    onSelected(value, option);
  };

  return (
    <Select
      allowClear={allowclear}
      options={options}
      optionLabelProp="prlabel"
      loading={isFetching}
      {...otherProps}
      onChange={handleChange}
    />
  );
};

export default ProductInput;

export const useGetProductList = () => {
  return useQuery('getProductList', () =>
    getProductList().then((res) => res.list || [])
  );
};
